// ── Utilities ─────────────────────────────────────────────────────────────────
export { cn } from './lib/utils'
export { parentRoute } from './lib/parent-route'

// ── Components ────────────────────────────────────────────────────────────────
export { Avatar, AvatarImage, AvatarFallback } from './components/avatar'
export { BackButton, type BackButtonProps } from './components/back-button'
export { HistoryIndexTracker } from './components/history-index-tracker'
export { Badge, badgeVariants } from './components/badge'
export {
  WeekStatusBadge,
  WeekStatusLegenda,
  onderhoudWeekKleur,
  dekkingWeekKleur,
  weekStatusTekst,
  WEEK_STATUS_UITLEG,
  type WeekStatusKleur,
  type WeekStatusBadgeProps,
} from './components/week-status-badge'
export { Button, buttonVariants } from './components/button'
export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
} from './components/card'
export {
  Dialog,
  DialogPortal,
  DialogOverlay,
  DialogClose,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from './components/dialog'
export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuCheckboxItem,
  DropdownMenuRadioItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
} from './components/dropdown-menu'
export { Input } from './components/input'
export { Label } from './components/label'
export { LogoDark, LogoLight } from './components/logo'
export { RadioGroup, RadioGroupItem } from './components/radio-group'
export {
  Sheet,
  SheetPortal,
  SheetOverlay,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetFooter,
  SheetTitle,
  SheetDescription,
} from './components/sheet'
export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
} from './components/table'
export {
  ResponsiveTable,
  DataList,
  type ResponsiveColumn,
  type ResponsiveTableProps,
  type ResponsiveTableSelection,
} from './components/responsive-table'
export { FilterBar, type FilterBarProps } from './components/filter-bar'
export { FormGrid, type FormGridProps } from './components/form-grid'
// batch-62 taken-ux (FO-464) — swipe-actie op een kaart (swipe naar rechts = actie).
export { SwipeActie, type SwipeActieProps } from './components/swipe-actie'
export {
  bepaalSwipeAs,
  swipeVerschuiving,
  swipeActiveerDrempel,
  swipeActiveert,
  type SwipeAs,
} from './lib/swipe'
export {
  type ToastProps,
  type ToastActionElement,
  ToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastAction,
  toastVariants,
} from './components/toast'
export { Toaster } from './components/toaster'
export { ConfirmProvider, useConfirm, type ConfirmOptions } from './components/confirm-dialog'
export {
  Select,
  SelectGroup,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectLabel,
  SelectItem,
  SelectSeparator,
  SelectScrollUpButton,
  SelectScrollDownButton,
} from './components/select'
export { Checkbox } from './components/checkbox'
export { Switch } from './components/switch'
export { Textarea } from './components/textarea'
export { Separator } from './components/separator'
export { Tabs, TabsList, TabsTrigger, TabsContent } from './components/tabs'
export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor } from './components/popover'
export { Combobox, MultiCombobox, type ComboboxOption } from './components/combobox'
export { TruncationNotice, type TruncationNoticeProps } from './components/truncation-notice'
export {
  LeverwijzeKiezer,
  LEVERWIJZE_KIEZER_DEFAULT_LABELS,
  type LeverwijzeKiezerProps,
  type LeverwijzeKiezerLabels,
} from './components/leverwijze-kiezer'
export { filterOptions, groupOptions, toggleValue } from './lib/combobox-filter'
export {
  Pagination,
  type PaginationProps,
  type PaginationLabels,
  DEFAULT_PAGINATION_LABELS,
  resolvePaginationLabels,
  paginationState,
  resolveTotalPages,
  clampPage,
  parsePageInput,
  buildPageHref,
  pageOptions,
  MOBILE_SELECT_MAX,
  LAZY_OPTIONS_THRESHOLD,
} from './components/pagination'
export {
  LocatiePicker,
  type LocatiePickerProps,
  type LocatiePickerValue,
  type LocatiePickerType,
  type LocatiePickerSources,
} from './components/locatie-picker'
export {
  buildLocatieOptions,
  decodeLocatieOptionValue,
  locatieValueToTriggerLabel,
  locatieValueToOptionValue,
  ONLINE_SENTINEL,
  CUSTOM_SENTINEL,
  type BuildLocatieOptionsOpts,
} from './lib/locatie-picker-options'
export {
  Command,
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from './components/command'
export { Calendar, type CalendarProps } from './components/calendar'
export { DatePicker, type DatePickerProps } from './components/date-picker'
export { MultiDatePicker, type MultiDatePickerProps } from './components/multi-date-picker'
export { DateTimePicker, type DateTimePickerProps } from './components/date-time-picker'
export { PlanningLegend } from './components/planning-legend'
export {
  RotatiePatroonEditor,
  RotatiePatroonStrip,
  DAG_CODE_KLEUR,
  DAY_CODE_ORDER,
  type DayCode,
  type RotatiePatroonLabels,
  type RotatiePatroonPresetOptie,
  type RotatiePatroonEditorProps,
} from './components/rotatie-patroon-editor'
export { EmptyState } from './components/empty-state'
export { PageSkeleton, type PageSkeletonProps } from './components/page-skeleton'
export { PageError, type PageErrorProps } from './components/page-error'
export { resolveFoutReferentie, operationIdVanAppInsights } from './lib/fout-referentie'
export {
  ClientTelemetryProvider,
  TelemetryUser,
  trackClientException,
  trackClientEvent,
  setTelemetryUser,
  flushClientTelemetry,
  isClientTelemetryReady,
  type ClientTelemetryProviderProps,
} from './components/client-telemetry'
// Bewust NIET geëxporteerd: rememberTelemetryBeaconConfig/-User - de provider
// en setTelemetryUser zijn de enige schrijvers, zodat SDK-context en
// beacon-attributie nooit kunnen divergeren.
export { verstuurTelemetryBeacon, TELEMETRY_BEACON_STORAGE_KEY } from './lib/telemetry-beacon'
export {
  foutVoorTelemetrie,
  padVoorTelemetrie,
  type FoutVoorTelemetrie,
} from './lib/telemetry-fout'
export {
  SignaturePad,
  type SignaturePadHandle,
  type SignaturePadProps,
} from './components/signature-pad'
// batch-68 handtekening (FO-345) - Mijn handtekening, het ondertekenvenster en het
// tekenvak met "gebruik mijn opgeslagen handtekening".
export {
  MijnHandtekeningKaart,
  type MijnHandtekeningKaartProps,
  type OpgeslagenHandtekeningWeergave,
  type HandtekeningActieUitkomst,
  type HandtekeningSoortUi,
} from './components/handtekening/mijn-handtekening-kaart'
export {
  OndertekenPaneel,
  type OndertekenPaneelProps,
  type OndertekenKeuze,
  type OndertekenUitkomst,
} from './components/handtekening/onderteken-paneel'
export {
  SignaturePadMetOpgeslagen,
  type SignaturePadMetOpgeslagenProps,
} from './components/handtekening/signature-pad-met-opgeslagen'
export { PhotoUpload, type PhotoUploadProps, type PhotoUploadSize } from './components/photo-upload'
// batch-67 middelen-inname (FO-499 §A4) — meervoudige bewijsfoto-upload (naast de
// enkelvoudige PhotoUpload) en het gedeelde uitgifte-/innameformulier.
export {
  MultiPhotoUpload,
  type MultiPhotoUploadProps,
  type MultiPhotoUploadUitkomst,
} from './components/multi-photo-upload'
export {
  MiddelFormulier,
  type MiddelFormulierProps,
  type MiddelFormulierLabels,
  type MiddelFormulierRegelExtraContext,
  type MiddelFormulierSubmitUitkomst,
} from './components/middel-formulier'
export {
  MIDDEL_FORMULIER_AFBOEK_SOORTEN,
  MIDDEL_FORMULIER_STATEN,
  MIDDEL_FOTO_MAX_AANTAL,
  MIDDEL_FOTO_MAX_BYTES,
  MIDDEL_FOTO_MIME_TYPES,
  controleerFotoBestand,
  fotoVerplichtVoorRegel,
  legeRegelWaarde,
  middelFormulierRichting,
  conceptItems,
  conceptVerlopen,
  naarConcept,
  pasConceptToe,
  MIDDEL_FORMULIER_CONCEPT_DAGEN,
  regelFoutPad,
  valideerMiddelFormulier,
  locatieVereistVoorRegel,
  verplichteHandtekeningen,
  type MiddelFormulierAfboekSoort,
  type MiddelFormulierConcept,
  type MiddelFormulierConceptItem,
  type MiddelFormulierItem,
  type MiddelFormulierModus,
  type MiddelFormulierRegelWaarde,
  type MiddelFormulierRichting,
  type MiddelFormulierStaat,
  type MiddelFormulierWaarden,
} from './lib/middel-formulier'
export {
  OnboardingVoortgangBar,
  type OnboardingVoortgangBarProps,
} from './components/onboarding-voortgang-bar'
export { DocumentActions, type DocumentActionsProps } from './components/document-actions'
export { PdfPreviewModal, type PdfPreviewModalProps } from './components/pdf-preview-modal'
export {
  fetchDocumentBlob,
  downloadDocument,
  triggerBlobDownload,
  ensureFileExtension,
  cleanMimeType,
  mimeFromFileName,
  documentKindFromMime,
  isStandaloneDisplay,
  DocumentFetchError,
  type DocumentKind,
  type FetchedDocument,
} from './lib/document-blob'

// ── Hooks ─────────────────────────────────────────────────────────────────────
export { useToast, toast } from './hooks/use-toast'
export {
  useReloadOnChunkError,
  isChunkLoadError,
  chunkPadUitFout,
} from './hooks/use-reload-on-chunk-error'

// ── batch-67 portal-thema (FO-504) ───────────────────────────────────────────
// Feestelijke thema's op het portal-dashboard: het bannermotief + logo-accent
// als inline SVG (STREEP-palet, samen < 10 kB), de compacte ThemaBanner (max.
// 96 px, reduced-motion, stopt na 6 s) en het LogoAccent-overlay voor de topbar.
export {
  ThemaMotief,
  ThemaLogoAccentMotief,
  type PortalThemaSoort as ThemaBannerSoort,
} from './components/portal-thema/thema-motieven'
export {
  ThemaBanner,
  type ThemaBannerProps,
  type ThemaBannerThema,
} from './components/portal-thema/thema-banner'
// Constanten los van de 'use client'-module (server-veilig als waarde te importeren).
export {
  THEMA_BANNER_ANIMATIE_MS,
  THEMA_DEELTJES,
  THEMA_DEELTJE_MAX_LINKS,
  THEMA_DEELTJE_VAL_S,
  THEMA_DEELTJE_TWINKEL_S,
} from './components/portal-thema/thema-constanten'
export { LogoAccent, type LogoAccentProps } from './components/portal-thema/logo-accent'
// batch-69 samenstellen (FO-509 §E7) - hoor- en voelbare scan-feedback (nooit stil).
export { speelScanFeedback } from './lib/scan-feedback'
